module.exports = {"m_inscrire":"M'inscrire","je_ne_possede_pas_encore_de_compte":"Je ne possède pas encore de compte"}


//////////////////
// WEBPACK FOOTER
// ./src/companies/casino/lang/fr/home/welcome.lang.json
// module id = +SAS
// module chunks = 1